import { createStyles, rem } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    box: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing.sm,
        padding: theme.spacing.xl,
        alignItems: "flex-start",
        borderRadius: rem(4),
        backgroundColor: theme.colors.gray[0],
        width: "100%",
    },
    variation: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing.xl,
        width: "100%",
    },
    hiddenVariation: {
        visibility: "hidden",
        maxHeight: 0,
        gap: 0,
    },
    wrapper: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing.sm,
        position: "relative",
    },
    buttons: {
        display: "flex",
        gap: theme.spacing.xs,
    },
    variationValidationAlert: {
        "& .mantine-Alert-wrapper": {
            display: "flex",
            alignItems: "center",
        },
    },
    variationWrapper: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing.xl,
        width: "100%",
    },
    titleWrapper: {
        display: "flex",
        justifyContent: "space-between",
    },
    badgeAuto: {
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        gap: rem(4),
        borderRadius: rem(50),
        backgroundColor: theme.colors.violet[5],
        color: theme.white,
        fontSize: rem(14),
        fontWeight: 400,
        padding: `0px ${rem(12)}`,
        letterSpacing: rem(1),
    },
    badgeOriginalEdited: {
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        gap: rem(4),
        borderRadius: rem(50),
        backgroundColor: theme.colors.violet[1],
        color: theme.colors.violet[8],
        fontSize: rem(14),
        fontWeight: 400,
        padding: `0px ${rem(12)}`,
        letterSpacing: rem(1),
        border: `1px solid ${theme.colors.violet[2]}`,
    },
    aiBadgesWrapper: {
        display: "flex",
        gap: theme.spacing.xs,
        flexWrap: "wrap",
        justifyContent: "flex-end",
    },
    bottomWrapper: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing.sm,
    },
}))
